module.exports = __webpack_public_path__ + "media/images/flags/pe-dbffa92e803a5cc83d4ea6a6900a6df4.svg";